import { Component } from '@angular/core';

@Component({
  selector: 'sh-platform-datepicker',
  templateUrl: './platform-datepicker.component.html',
  standalone: false
})
export class PlatformDatepickerComponent {
  date: Date[] = [
    new Date(),
    new Date()
  ];
  constructor() {}
}
